import React, { useState, useEffect } from "react";
import LocationImg from "../assets/img/location-text-new.svg";
import BannerShapeBg from "../assets/img/banner-shape-bg.svg";
import LocationBannerIcon from "../assets/img/location-banner-icon.svg";
import LimitedOffer from "../assets/img/limited-offer.svg";
import {
  getBookingApi,
  getasakusa,
  getShibuya,
  getShinagawa,
  getShinjuku,
  getOsaka,
  getMtfuji,
  getHelicopter,
  getRainbow,
} from "../config/config";
import { fetchApi } from "../utils/apiHelper";
import BookingFormContent from "./BookingFormContent";
import HomeMonkeyShape from "../assets/images/monkey-banner.png";

const getApiInfoForTab = (tab) => {
  if (!tab) return { api: getasakusa, routeId: "asakusa" };
  const linkStr = (tab.link || "").toLowerCase();
  const titleStr = (tab.title || "").toLowerCase();

  if (linkStr.includes("asakusa") || titleStr.includes("asakusa"))
    return { api: getasakusa, routeId: "asakusa" };
  if (linkStr.includes("shibuya") || titleStr.includes("shibuya"))
    return { api: getShibuya, routeId: "shibuya" };
  if (
    linkStr.includes("shinagawa") ||
    titleStr.includes("tokyo tower") ||
    linkStr.includes("tokyotower")
  )
    return { api: getShinagawa, routeId: "shinagawa" };
  if (linkStr.includes("shinjuku") || titleStr.includes("shinjuku"))
    return { api: getShinjuku, routeId: "shinjuku" };
  if (linkStr.includes("osaka") || titleStr.includes("osaka"))
    return { api: getOsaka, routeId: "osaka" };
  if (linkStr.includes("fuji") || titleStr.includes("fuji"))
    return { api: getMtfuji, routeId: "fujitour" };
  if (linkStr.includes("helicopter") || titleStr.includes("helicopter"))
    return { api: getHelicopter, routeId: "helicopter" };
  if (linkStr.includes("rainbow") || titleStr.includes("rainbow"))
    return { api: getRainbow, routeId: "rainbow" };
  return { api: getasakusa, routeId: "asakusa" }; // fallback
};

const HomeBookingWidget = () => {
  const [routes, setRoutes] = useState([]);
  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    const fetchRoutes = async () => {
      try {
        const token = localStorage.getItem("token");
        const data = await fetchApi(getBookingApi.url, {
          method: getBookingApi.method,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        
        setRoutes(data || []);
        if (data && data.length > 0) {
          setActiveTab(data[0]);
        }
      } catch (error) {
        console.error("Error fetching routes:", error);
      }
    };
    fetchRoutes();
  }, []);

  if (!routes.length || !activeTab) {
    return null; // Or a loading skeleton
  }

  const activeApiInfo = getApiInfoForTab(activeTab);

  return (
    <section className="py-[40px] md:py-[70px] relative bg-[#F6F3E9]">
      <img src={BannerShapeBg} alt="" className="absolute w-full top-0" />
      <div className="container mx-auto 2xl:px-0 lg:px-[25px] px-[15px]">
        <div className="main-location-row flex flex-wrap 2xl:gap-15 lg:gap-10 gap-5 justify-center lg:mb-10 mb-10">
          <div className="relative">
            <span className="[clip-path:polygon(12%_0%,100%_0,100%_100%,0%_100%)] lg:text-[24px] text-[16px]  font-semibold italic lg:py-1 py-0.5 lg:pl-8 pl-5 lg:pr-3 pr-1 text-[#442202] bg-gradient-to-r from-[#FBBA00] to-[#FFED00]">
              Asakusa
            </span>
            <img
              src={LocationBannerIcon}
              alt=""
              className="absolute left-0 lg:w-[42px] w-[24px] bottom-0 lg:left-[-20px] left-[-12px]"
            />
          </div>
          <div className="relative">
            <span className="[clip-path:polygon(12%_0%,100%_0,100%_100%,0%_100%)] lg:text-[24px] text-[16px]  font-semibold italic lg:py-1 py-0.5 lg:pl-8 pl-5 lg:pr-3 pr-1 text-[#442202] bg-gradient-to-r from-[#FBBA00] to-[#FFED00]">
              Shibuya
            </span>
            <img
              src={LocationBannerIcon}
              alt=""
              className="absolute left-0 lg:w-[42px] w-[24px] bottom-0 lg:left-[-20px] left-[-12px]"
            />
          </div>
          <div className="relative">
            <span className="[clip-path:polygon(12%_0%,100%_0,100%_100%,0%_100%)] lg:text-[24px] text-[16px]  font-semibold italic lg:py-1 py-0.5 lg:pl-8 pl-5 lg:pr-3 pr-1 text-[#442202] bg-gradient-to-r from-[#FBBA00] to-[#FFED00]">
              Tokyo Tower
            </span>
            <img
              src={LocationBannerIcon}
              alt=""
              className="absolute left-0 lg:w-[42px] w-[24px] bottom-0 lg:left-[-20px] left-[-12px]"
            />
          </div>
          <div className="relative">
            <span className="[clip-path:polygon(12%_0%,100%_0,100%_100%,0%_100%)] lg:text-[24px] text-[16px]  font-semibold italic lg:py-1 py-0.5 lg:pl-8 pl-5 lg:pr-3 pr-1 text-[#442202] bg-gradient-to-r from-[#FBBA00] to-[#FFED00]">
              Shinjuku
            </span>
            <img
              src={LocationBannerIcon}
              alt=""
              className="absolute left-0 lg:w-[42px] w-[24px] bottom-0 lg:left-[-20px] left-[-12px]"
            />
          </div>
          <div className="relative">
            <span className="[clip-path:polygon(12%_0%,100%_0,100%_100%,0%_100%)] lg:text-[24px] text-[16px]  font-semibold italic lg:py-1 py-0.5 lg:pl-8 pl-5 lg:pr-3 pr-1 text-[#442202] bg-gradient-to-r from-[#FBBA00] to-[#FFED00]">
              Osaka
            </span>
            <img
              src={LocationBannerIcon}
              alt=""
              className="absolute left-0 lg:w-[42px] w-[24px] bottom-0 lg:left-[-20px] left-[-12px]"
            />
          </div>
          <div className="relative">
            <span className="[clip-path:polygon(12%_0%,100%_0,100%_100%,0%_100%)] lg:text-[24px] text-[16px]  font-semibold italic lg:py-1 py-0.5 lg:pl-8 pl-5 lg:pr-3 pr-1 text-[#442202] bg-gradient-to-r from-[#FBBA00] to-[#FFED00]">
              Rainbow
            </span>
            <img
              src={LocationBannerIcon}
              alt=""
              className="absolute left-0 lg:w-[42px] w-[24px] bottom-0 lg:left-[-20px] left-[-12px]"
            />
          </div>
        </div>
        <div className="location-row lg:mb-20 mb-10 lg:pl-[30px]">
          <img src={LocationImg} alt="" />
          <div className="2xl:pl-[10%] xl:pl-[12%] lg:pl-[14%] pl-[25%] 2xl:w-[45%] xl:w-[44%] w-[98%] lg:mt-[-5px]">
            <p className="xl:text-[20px] lg:text-[18px] text-[16px] text-[#666666]">
              As a leading and most established go-kart tour provider offering
              safe, unforgettable rides.
            </p>
          </div>
        </div>
        <div class="relative">
          <div>
            <img
              src={HomeMonkeyShape}
              className="absolute lg:block hidden sm:top-[-213px] top-[-130px] right-[70px] sm:w-[180px] w-[110px] h-auto block"
              alt={"Monkey Shape"}
            />
          </div>
          {/* Main Widget Container */}
          <div className="border-[2px] border-[#442202] rounded-[20px] bg-white shadow-[0px_4px_14px_0px_#DC354559] ">
            <div className="flex flex-col md:flex-row items-start  p-2 md:p-6">
              {/* Left Sidebar (Tabs) */}

              <div className="w-full md:w-[250px] md:space-y-5 md:gap-x-0 gap-5 md:border-r-[1px] border-[#000000] grid md:grid-cols-1 grid-cols-3 pr-0 md:pr-6 mr-0 md:mr-5  overflow-y-auto custom-scrollbar">
                {routes.map((tab) => (
                  <div className="relative w-full h-full">
                    <button
                      key={tab.id}
                      onClick={() => setActiveTab(tab)}
                      className={`cursor-pointer  lg:flex-row flex-col md:items-start items-center justify-left  h-full flex md:gap-4 gap-2 border-[1px] p-[7px] w-full rounded-[12px] transition-all relative ${tab.offer !== 0 && tab.offer && "md:pt-[50px] pt-[35px]"} ( ${
                        activeTab.id === tab.id
                          ? "border-[#FF6F00] bg-[#FF6F000D]"
                          : "border-[#C0BBB7] border-dashed"
                      }`}
                    >
                      {/* Icon - small circle like image 2 */}
                      <div
                        className={`lg:w-12 lg:h-12 lg:min-w-12 lg:min-h-12 md:min-w-10 md:min-h-10 w-12 h-12 lg:p-3 md:p-2 p-2 rounded-full  flex items-center justify-center overflow-hidden ${activeTab.id === tab.id ? "bg-[#442202]" : "bg-[#C8C8C8]"}`}
                      >
                        <img
                          src={tab.img}
                          alt={tab.title}
                          className="w-full object-contain"
                          onError={(e) => (e.target.style.display = "none")}
                        />
                      </div>
                      <div className="md:text-start text-center">
                        <h4
                          className={`font-semibold md:text-[16px] text-[14px] text-[#121212]`}
                        >
                          {tab.title}
                        </h4>

                        <p className="lg:text-[14px] text-[12px] text-[#888] mb-0 rounded-[24px] md:py-1 py-0.5">
                          {tab.time}
                        </p>

                        <p
                          className={`font-semibold text-[#442202] lg:text-[16px] text-[14px]`}
                        >
                          {tab.price}
                        </p>

                        {tab.offer !== 0 && tab.offer && (
                          // <span className="text-red-500 text-[10px]">
                          //   Limited Offer!
                          // </span>
                          <img
                            src={LimitedOffer}
                            className="absolute top-0 w-full left-0"
                          />
                        )}
                      </div>
                    </button>
                  </div>
                ))}
              </div>

              {/* Right Side (Form Content) */}
              <div className="flex-1 min-w-0 pt-4 md:pt-0">
                <div className="hidden lg:block">
                  <img
                    src={activeTab?.previewImg}
                    className="pt-1 pb-1 block  m-auto w-auto max-w-full h-[130px] px-[10px] max-h-[max-content]"
                    alt={activeTab?.title}
                  />
                </div>
                <div className="lg:hidden block">
                  <img
                    src={activeTab?.previewMobileImg}
                    className="pt-1 pb-1 block  m-auto w-auto max-w-full md:h-[130px] h-auto px-[10px] max-h-[max-content]"
                    alt={activeTab?.title}
                  />
                </div>
                <BookingFormContent
                  key={activeApiInfo.routeId}   
                  apiEndpoint={activeApiInfo.api}
                  routeId={activeApiInfo.routeId}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeBookingWidget;
